import { SurfaceProps } from '../rendering'
import { LinearTransform } from '@st/geom'

export function HTMLSurface({ drawOp, debug = false, width, height }: SurfaceProps) {
  return (
    <div style={{ position: 'relative', width, height }}>
      <HTMLSurfaceElement drawOp={drawOp} debug={debug} />
    </div>
  )
}

function HTMLSurfaceElement({
  drawOp,
  debug = false
}: {
  drawOp: SurfaceProps['drawOp']
  debug?: boolean
}) {
  switch (drawOp.type) {
    case 'text':
      return (
        <span
          style={{
            position: 'absolute',
            left: drawOp.bounds.x,
            top: drawOp.bounds.y,
            width: drawOp.bounds.width,
            height: drawOp.bounds.height,
            fontFamily: 'Helvetica',
            fontWeight: drawOp.font.weight,
            fontSize: drawOp.font.size,
            color: drawOp.color,
            whiteSpace: 'pre',
            outline: debug ? '1px solid red' : 'none',
            overflow: 'hidden',
            fontKerning: drawOp.kerning ? 'normal' : 'none',
            lineHeight: drawOp.line_height,
            textAlign: drawOp.text_align
          }}
          data-element-type="text"
          data-element-id={drawOp.id}
        >
          {drawOp.text}
        </span>
      )

    case 'rect':
      return (
        <div
          style={{
            position: 'absolute',
            left: drawOp.bounds.x,
            top: drawOp.bounds.y,
            width: drawOp.bounds.width,
            height: drawOp.bounds.height,
            borderColor: drawOp.border?.color,
            borderWidth: drawOp.border?.width,
            borderStyle: drawOp.border?.width ? 'solid' : 'none',
            borderRadius: drawOp.border?.radius,
            backgroundColor: drawOp.background_color
          }}
          data-element-type="rect"
          data-element-id={drawOp.id}
        />
      )

    case 'path':
      return (
        <svg
          style={{
            position: 'absolute',
            left: drawOp.bounds.x,
            top: drawOp.bounds.y,
            width: drawOp.bounds.width,
            height: drawOp.bounds.height
          }}
          viewBox={`0 0 ${drawOp.bounds.width} ${drawOp.bounds.height}`}
          data-element-type="path"
          data-element-id={drawOp.id}
        >
          <path
            d={drawOp.path}
            fill={drawOp.fill ?? 'none'}
            stroke={drawOp.stroke}
            strokeWidth={drawOp.stroke_width}
            transform={drawOp.transform ? LinearTransform.toSVG(drawOp.transform) : undefined}
          />
        </svg>
      )

    case 'group':
      return (
        <div
          style={{
            position: 'absolute',
            left: drawOp.bounds.x,
            top: drawOp.bounds.y,
            width: drawOp.bounds.width,
            height: drawOp.bounds.height,
            outline: debug ? '1px solid blue' : 'none'
          }}
          data-element-type="group"
          data-element-id={drawOp.id}
        >
          {drawOp.children.map((c) => (
            <HTMLSurfaceElement key={c.id} drawOp={c} debug={debug} />
          ))}
        </div>
      )
  }
}
